import {combineReducers} from "redux";
import AppReducer from '../../Modules/Common/App/Redux/Reducer';
import AuthReducer from '../../Modules/Common/Auth/Redux/Reducer';
import UserReducer from '../../Modules/Core/Users/Redux/Reducer';
import RoleReducer from "../../Modules/Core/Roles/Redux/Reducer";
import PermissionReducer from "../../Modules/Core/Permission/Redux/Reducer";
import SettingReducer from "../../Modules/Core/Settings/Redux/Reducer";
import OfficeDashboardReducer  from "../../Modules/Core/Dashboard/Redux/Reducer";

import DashboardReducer from '../../Modules/Core/Dashboard/Redux/Reducer';
import ReportReducer from '../../Modules/Core/Report/Redux/Reducer';
import DownloadReducer from '../../Modules/Core/Download/Redux/Reducer';
import DepartmentReducer from '../../Modules/Roster/Department/Redux/Reducer';
import RosterReducer from '../../Modules/Roster/Roster/Redux/Reducer';
import RosterArchiveReducer from '../../Modules/Roster/Archive/Redux/Reducer';
import ThemesReducer from '../../Modules/Core/Themes/Redux/Reducer';
import RosterJobsReducer from '../../Modules/Core/RosterJobs/Redux/Reducer';

export const authReducer = combineReducers({
    app: AppReducer,
    auth:AuthReducer,
})

export const officeReducer = combineReducers({
    app: AppReducer,
    auth:AuthReducer,
    dashboard:OfficeDashboardReducer,
    settings:SettingReducer,
    permissions:PermissionReducer,
    roles:RoleReducer,
    users:UserReducer,
    dashboards: DashboardReducer,
    reports: ReportReducer,
    downloads: DownloadReducer,
    departments: DepartmentReducer,
    rosters: RosterReducer,
    rosterArchive: RosterArchiveReducer,
    themes: ThemesReducer,
    rosterJobs: RosterJobsReducer,
})
